import React from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";
import VastuCompassPlaceholder from "../components/VastuCompassPlaceholder";
import { logActivity } from "../utils/activity";
import { NavLink } from "react-router-dom";
import homeData from "../data/home.json";

export default function Home() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={homeData.seo?.title}
        description={homeData.seo?.description}
        ogType="website"
        ogImage={homeData.seo?.ogImage}
      />
      <section className="section-padding mx-auto grid w-full max-w-6xl gap-10 md:grid-cols-[1.2fr_0.8fr]">
        <div className="space-y-6">
          {/* <!-- Replace with dynamic content from JSON --> */}
          <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
            {homeData.hero.tagline}
          </p>
          <h1 className="page-title">
            {homeData.hero.headline}
          </h1>
          <p className="text-lg text-slate-600">
            {homeData.hero.subheadline}
          </p>
          <div className="flex flex-wrap gap-3">
            <NavLink
              to="/login"
              className="btn btn-primary"
              onClick={() =>
                logActivity("cta_click", { label: homeData.hero.primaryCta })
              }
            >
              {homeData.hero.primaryCta}
            </NavLink>
            <NavLink
              to="/signup"
              className="btn btn-secondary"
              onClick={() =>
                logActivity("cta_click", { label: homeData.hero.secondaryCta })
              }
            >
              {homeData.hero.secondaryCta}
            </NavLink>
          </div>
        </div>
        <motion.div
          className="flex items-center justify-center rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <VastuCompassPlaceholder />
          {/* <!-- Replace with dynamic content from JSON --> */}
        </motion.div>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto w-full max-w-6xl">
          <h2 className="text-2xl font-semibold text-slate-900">
            Core benefits of Manage Your Vastu
          </h2>
          <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {homeData.features.map((feature) => (
              <motion.div
                key={feature.title}
                className="card card-hover p-6"
                whileHover={{ y: -4 }}
              >
                <div className="text-2xl">{feature.icon}</div>
                <h3 className="mt-4 text-lg font-semibold text-slate-900">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="mx-auto w-full max-w-6xl">
          <h2 className="text-2xl font-semibold text-slate-900">
            How Manage Your Vastu works
          </h2>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {homeData.steps.map((step) => (
              <div key={step.title} className="card p-6">
                <div className="text-2xl">{step.icon}</div>
                <h3 className="mt-4 text-lg font-semibold text-slate-900">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto w-full max-w-6xl">
          <h2 className="text-2xl font-semibold text-slate-900">
            Trusted by vastu professionals
          </h2>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {homeData.testimonials.map((item) => (
              <div key={item.name} className="card p-6">
                <p className="text-sm text-slate-600">"{item.quote}"</p>
                <p className="mt-4 text-sm font-semibold text-slate-900">
                  {item.name}
                </p>
                <p className="text-xs text-slate-500">{item.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="card mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-6 bg-gradient-to-r from-amber-50 to-white px-6 py-10 md:flex-row md:items-center md:px-10">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900">
              Ready to launch your next analysis?
            </h2>
            <p className="mt-2 text-sm text-slate-600">
              Get started with Manage Your Vastu today.
            </p>
          </div>
          <NavLink
            to="/login"
            className="btn btn-primary"
            onClick={() =>
              logActivity("cta_click", { label: "Start Manage Your Vastu" })
            }
          >
            Start Manage Your Vastu
          </NavLink>
        </div>
      </section>
    </div>
  );
}
